const { tidalAxios } = require('@tidal/axios');
const config = require('../config');
const util = require('../utils/tracking.util');
const axios = tidalAxios('tracking', util.isServer() ? config.tidalAxiosConfig : undefined);
const { v1: uuidv1 } = require('uuid');

/**
 * @param {boolean} useProductionEndpoint
 * @param {string} eventName
 * @param {import('@tidal/tracking').TrackingEventParams} params
 * @param {string} [groupName]
 * @returns {Promise<any>}
 */
module.exports.sendTrackingEvent = (useProductionEndpoint, eventName, params, groupName = 'onboarding') => {
    return axios.post(
        useProductionEndpoint ? config.TIDAL_TRACKING_PROD_ENDPOINT : config.TIDAL_TRACKING_STAGE_ENDPOINT, {
            batchId: '',
            events: [{
                group: groupName,
                name: eventName,
                version: 1,
                ts: Date.now(),
                uuid: uuidv1(),
                client: params.client,
                payload: params.payload,
            }],
        }, {
            headers: {
                'x-tidal-token': config.TIDAL_TOKEN,
            },
        });
};
